import { Navigate, useSearchParams } from "react-router-dom";
import { EXPERT_MEMBERSHIP_PATH } from "@/shared/constants/expertMembership.routes";

export function ExpertMembershipJoinRedirect() {
  return <Navigate to={`${EXPERT_MEMBERSHIP_PATH}#join-requests`} replace />;
}

export function ExpertMembershipApprovalRedirect() {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  params.delete("section");
  const search = params.toString();
  return (
    <Navigate
      to={`${EXPERT_MEMBERSHIP_PATH}${search ? `?${search}` : ""}#approval`}
      replace
    />
  );
}
